import styled from 'styled-components';

export const ContentStyled = styled.div`
  position: relative;
  min-height: 30vh;
`;
